import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { LoginRequest, LoginResponse, UserInfoViewModel } from 'src/app/models/viewmodels';
import { AuthService } from 'src/app/services/auth.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { DataService } from 'src/app/services/data-api.service';
import { BrandService } from '../../../state';
import { TogglePasswordDirective } from 'src/app/directives/toggle-password.directive';
import { documentOutline, peopleOutline, barChartOutline, arrowForwardOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { ErrorMessagesComponent } from 'src/app/components/util/error-messages/error-messages.component';
import { ValidatorsHelper } from '../../util/validators-helper';

@Component({
  standalone: true,
  selector: 'user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss'],
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TogglePasswordDirective,
    ErrorMessagesComponent,
  ],
})
export class UserLoginComponent implements OnInit {
  public userMessage: string = '';

  //cns: put to interface
  loginRequest: LoginRequest = { Email: '', Password: '' };

  userLoginFormGroup: FormGroup = new FormGroup({});
  approvalUserId: string = null;
  projectQuoteId: string = null;
  scheduleId: string = null;
  projectId: string = null;

  companyLogoImagePath: string = '';
  isRequiredField = ValidatorsHelper.isRequired;

  constructor(
    private dataService: DataService,
    private brandService: BrandService,
    private userInfoService: UserInfoService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private userNotificationService: UserNotificationService,
  ) {
    this.setUserLoginFormGroup();

    //this.companyLogoImagePath = this.userInfoService.getLogoImageUrl();
    //console.log('user-login', 'constructor', 'logoImagePath', this.companyLogoImagePath);

    addIcons({
      documentOutline,
      peopleOutline,
      barChartOutline,
      arrowForwardOutline,
    });
  }

  public data: any;
  private activatedRoute = inject(ActivatedRoute);

  async ngOnInit() {
    try {
      let isEngineerUrl =
        window.location.href.toLowerCase().includes('specifymanagerpro.com') ||
        window.location.href.toLowerCase().includes('localhost:8123');
      if (isEngineerUrl) {
        this.companyLogoImagePath = '/assets/images/SpecifyManagerLogo.png';
      } else {
        this.companyLogoImagePath = '/assets/images/QuotifyLogoImage.png';
      }
    } catch (error) {
      console.error(
        'user-login',
        'ngOnInit',
        'error getting logo image path',
        error,
      );
    }

    //this.approvalUserId = this.route.snapshot.queryParamMap.get('approvalUserId');
    this.approvalUserId = history.state.userApproval;
    this.projectQuoteId = history.state.projectQuoteId;
    this.scheduleId = history.state.scheduleId;
    this.projectId = history.state.projectId;

    this.route.data.subscribe((data) => (this.data = data));
    let parameters =
      this.data?.action ??
      (this.activatedRoute.snapshot.paramMap.get('action') as string);
    if (parameters === 'logout') {
      this.authService.logout();
      this.userMessage = 'You have been logged out.';
    } else {
      this.userMessage = '';
    }
    console.log('user-login', 'ngOnInit', 'parameters', parameters);
  }

  setUserLoginFormGroup() {
    //console.log('project-form', 'setProjectFormGroup', 'projectSchedule', this.project);
    this.userLoginFormGroup = this.formBuilder.nonNullable.group({
      Email: [this.loginRequest.Email, [Validators.required]],
      Password: [this.loginRequest.Password, [Validators.required]],
    });
  }

  async loginUser() {
    let loginData = this.userLoginFormGroup.value;
    //console.log('user-login', 'loginUser', 'loginData', loginData);
    if (loginData.Email === '' || loginData.Password === '') {
      this.userMessage = 'Email and password are required.';
      return;
    }

    //clear out existing user
    this.authService.removeToken();
    //removing any impersonation that wasn't cleared out (an exception)
    localStorage.removeItem('ImpersonatingUserId');
    localStorage.removeItem('userInfo');

    let loginObs = this.dataService.loginUser(loginData);
    loginObs.subscribe((data: LoginResponse) => {
      if (data.AppUser?.UserId > 0) {
        //using UserInfoViewModel instead of AppUser
        //this.userInfoService.setAppUser(data.AppUser);
        //localStorage.setItem("currentUser", JSON.stringify(data.AppUser));
        if (data.Authenticated) {
          this.userInfoService.refreshUserInfo().then(() => {
            //this.router.navigate(['/topmenu/project/']);
            //this.brandService.setAppRootTheme(data.AppUser.DefaultCompany.DefaultBrandId);
            if (!!this.approvalUserId) {
              //this.router.navigate(["topmenu/admin/admin-company/internal-employee-list"],{ queryParams: { approvalUserId: this.approvalUserId } });
              // this.router.navigate(["topmenu/project"]);
              window.location.href =
                '/topmenu/admin/admin-company/internal-employee-list?approvalUserId=' +
                this.approvalUserId;
            } else if (
              !!this.projectQuoteId &&
              !!this.scheduleId &&
              !!this.projectId
            ) {
              // console.log('navigating to project quote with params', this.projectQuoteId, this.scheduleId);
              window.location.href =
                '/topmenu/project/project-detail/' +
                this.projectId +
                '/project-quote-form?projectQuoteId=' +
                this.projectQuoteId +
                '&projectScheduleId=' +
                this.scheduleId;
            } else {
              window.location.href = '/topmenu/project/';
            }
          });
        } else {
          this.userMessage = 'Login failed.';
          //console.log('login failed', data, this.userMessage);
          if (data?.UserMessage != null && data.UserMessage.length > 0) {
            //console.log('updating user message', data.UserMessage);
            this.userMessage = data.UserMessage;
          }
        }
      } else {
        this.userMessage = 'Login failed.';
        //console.log(this.userMessage, data);
        if (data?.UserMessage != null && data.UserMessage.length > 0) {
          //console.log('updating user message', data.UserMessage);
          this.userMessage = data.UserMessage;
        }
      }
    });
  }

  public onRegisterClick() {
    window.location.href = '/user/user-register';
  }

  OnForgotPassword() {
    window.location.href = '/user/user-forgot-password';
    //this.router.navigate(["user/user-forgot-passwordz"]);
  }
}
